// extracted by mini-css-extract-plugin
export default {"ourProjectContainer":"OurProjects_ourProjectContainer__Q54fI","ourProjectList":"OurProjects_ourProjectList__YkvDa"};